<template>
  <div class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col>
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :error-messages="descriptionErrors"
            :counter="30"
            label="Descrição do Agendamento"
            outlined
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
        <v-col>
          <v-select
            dense
            v-model="form.diaMes"
            :items="hora"
            :error-messages="diaMesErrors"
            label="Dia do Mês"
            outlined
            @input="$v.form.diaMes.$touch()"
            @blur="$v.form.diaMes.$touch()"
          />
        </v-col>
        <v-col>
          <v-menu
            ref="menu"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                dense
                v-model="form.hora"
                label="Hora"
                prepend-inner-icon="mdi-clock-outline"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-time-picker
              v-if="menu2"
              v-model="form.hora"
              scrollable
              no-title
              format="24hr"
              color="bluePcm"
              @click:minute="$refs.menu.save(time)"
            />
          </v-menu>
        </v-col>
      </v-row>
      <DraggAndDrop
        dragname="Ações"
        :valoresDisponiveisComboBox="acoesDisponiveis"
        @dragUpdate="updateAcoes($event)"
        :opcoesSelecionadas="acoesSelecionadas"
        class="mr-4"
      />

      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'

import agendamentosStore from '../_store'
import acoes from '../_components/acoes'
import AgendamentosHttpService from '../_services/AgendamentosHttpService'
import { validateData, validateComputed } from '../_validates/validateMes'

import DraggAndDrop from './DraggAndDrop'

export default {
  name: 'AbaAgendamentoMes',
  mixins: [validationMixin],
  props: {
    _id: String,
  },
  components: { Snackbar, DraggAndDrop, FixedButtons },
  data: () => ({
    time: null,
    menu: false,
    menu2: false,
    modal2: false,
    form: {
      active: true,
      description: '',
      tipo: 'mensal',
      diaMes: new Date().toISOString().substr(0, 10),
      hora: moment().format('HH:mm'),
      acao: [],
    },
    acoesSelecionadas: [],
    acoesDisponiveis: [...acoes],
    hora: [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
    ],
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),
  validations: {
    ...validateData,
  },
  computed: {
    ...validateComputed,
    ...mapGetters('abaAgendamentoMesModulePABXStore', ['getagendamentoSelecionado']),
  },
  async created() {
    registerVuexModule(this.$store, 'abaAgendamentoMesModulePABXStore', agendamentosStore)

    if (this._id) {
      this.form = this.getagendamentoSelecionado

      this.acoesSelecionadas = Object.values(this.getagendamentoSelecionado.acao)
    }

    this.showSkeleton = false
  },

  methods: {
    cancelEvent(parent) {
      parent.resetPicker()
      this.$emit('input', null)
    },

    updateAcoes(event) {
      this.form.acao = event
    },

    async salvar() {
      let count = 0
      this.pararLoader.parar = false

      if (this.form.acao.length > 0) {
        this.form.acao.forEach(reg => {
          if (reg.regex_id || reg.agente_id != '' || reg.backup_total != '' || reg.deparment_id != '') {
            count++
          }
        })
        if (count <= 0) {
          this.text = 'Favor inserir os valores dentro da ação selecionada.'
          this.snackbar = true
          this.pararLoader.parar = true
          return
        }
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this._id) {
          await AgendamentosHttpService.puttarefa(this.form)
        } else {
          await AgendamentosHttpService.posttarefa(this.form)
        }

        this.$router.push({ name: 'agendamento' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'agendamento' })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
